<template>
  <div id="app" ref="appEntry">
    <LanguageSelector></LanguageSelector>
    <Topbar v-if="$store.state.admin"></Topbar>
    <div id="content" v-if="$store.state.admin && data_loaded">
      <router-view style="padding-top: 15px" />
      <div id="copyright-bar">
        <p style="font-size: 12px">
          <b>{{ $t("copyright.built-by") }}</b> <a href="https://sportips.fr" target="_blank"><img
              src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
        </p>
      </div>
    </div>
    <div id="sponsor-bar">
      <img class="sponsor-image" v-if="$store.state.admin" :src="$store.state.admin.sponsor_url" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Topbar from "@/components/Topbar.vue";
import LanguageSelector from "@/components/LanguageSelector.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: { Topbar, Loading, LanguageSelector },
  data() {
    return {
      data_loaded: false,
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.name != "live") {
        this.$store.commit("clearRefreshIntervals");
      }
      if (this.$store.state.module.nom) {
        document.title = this.$store.state.module.nom + " | " + to.name;
      } else {
        document.title = "Sportips | " + to.meta.title;
      }
    },
    "$store.state.module"(newVal, from) {
      if (this.$store.state.module.nom) {
        document.title = this.$store.state.module.nom + " | " + this.$route.name;
      } else {
        document.title = "Sportips";
      }
    },
  },
  methods: {
    setVisibilityParticipantsTab() {
      var start_date = this.$store.state.module.date_course;
      start_date = start_date.split("-");
      var formated_date = new Date(parseInt(start_date[2], 10), parseInt(start_date[1], 10) - 1, parseInt(start_date[0]), 10).getTime();
      var current_date = new Date().getTime();
      if (current_date >= formated_date || this.$store.state.module.live_en_cours) {
        this.$store.state.showParticipantsTab = false;
      }
    },

    loadAdminData() {
      var _this = this;
      axios.get(this.$store.state.base_url + "/admin/get.php?id=" + this.$store.state.module.id).then(function (response) {
        _this.$store.commit("initAdmin", response.data);
        _this.$root.$el.style.setProperty("--primary-color", _this.$store.state.admin.primary_color);
        _this.$root.$el.style.setProperty("--background-color", _this.$store.state.admin.background_color);
        _this.$root.$el.style.setProperty("--footer-color", _this.$store.state.admin.footer_color);
        _this.$root.$el.style.setProperty("--header-image", "url('" + _this.$store.state.admin.header_url + "')");
        _this.$root.$el.style.setProperty("--footer-image", "url('" + _this.$store.state.admin.footer_url + "')");
        _this.$forceUpdate();
        _this.$store.commit("unsetLoading");
      });
    },
    isPcCourse() {
      let key = "pc_course_" + this.$store.state.module.base;
      if (this.$cookies.isKey(key)) {
        let islog = this.$cookies.get(key);
        if (islog == 1) {
          this.$store.state.logged = true;
        }
      }
    },
    async loadParcours() {
      this.$store.commit("setLoading");
      await this.$store.dispatch("parcours/fetchList");
      this.$store.commit("unsetLoading");
    },
  },
  async created() {
    this.$store.commit("setLoading");
    let response = await axios.get(this.$store.state.base_url + "/module/get.php?base=" + this.$route.params.base);
    if (response.data) {
      this.$store.state.module = response.data;
      this.setVisibilityParticipantsTab();
      if (this.$store.state.module.id) {
        this.loadAdminData();
        this.isPcCourse();
        await this.loadParcours();
      }
    }
    this.data_loaded = true;
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rubik:wght@400;500;700&display=swap");

#app {
  --primary-color: #f29200;
  --background-color: #e9f1f3;
  --footer-color: #2f3a45;
  --header-image: url("https://sportips.fr/race/uploads/topbar_bg.jpg");
}

@import "./scss/style.scss";
</style>
